export default "__VITE_ASSET__DuDT1e5E__"